import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	fileLoading: false,
	preUploadDocumentsList: [],
	preUploadPhotosList: [],
	documentsList: [],
	photosList: [],
	documentsTotal: 0,
	photosTotal: 0,
	fileUploadType: ''
};

const fileUploadSlice = createSlice({
	name: 'fileUpload',
	initialState,
	reducers: {
		resetFileUploadSlice() {
			return initialState;
		},
		setFileLoading(state, action) {
			state.fileLoading = action.payload;
		},
		setPreUploadDocumentsList(state, action) {
			state.preUploadDocumentsList = action.payload;
		},
		setPreUploadPhotosList(state, action) {
			state.preUploadPhotosList = action.payload;
		},
		setDocumentsList(state, action) {
			const updatedList = [...initialState.documentsList, ...action.payload];
			state.documentsList = [...updatedList];
		},
		setPhotosList(state, action) {
			const updatedList = [...initialState.photosList, ...action.payload];
			state.photosList = updatedList;
		},
		setDocumentsTotal(state, action) {
			state.documentsTotal = action.payload;
		},
		setPhotosTotal(state, action) {
			state.photosTotal = action.payload;
		},
		setFileUploadType(state, action) {
			state.fileUploadType = action.payload;
		},
		resetDocuments(state) {
			state.documentsList = [];
			state.documentsTotal = 0;
		},
		resetPhotos(state) {
			state.photosList = [];
			state.photosTotal = 0;
		}
	}
});

export const {
	resetFileUploadSlice,
	setFileLoading,
	setPreUploadDocumentsList,
	setPreUploadPhotosList,
	setDocumentsList,
	setPhotosList,
	setDocumentsTotal,
	setPhotosTotal,
	setFileUploadType,
	resetDocuments,
	resetPhotos
} = fileUploadSlice.actions;

export default fileUploadSlice.reducer;

export const fileLoadingSelector = state => state.fileUpload.fileLoading;
export const preUploadDocumentSelector = state => state.fileUpload.preUploadDocumentsList;
export const preUploadPhotoSelector = state => state.fileUpload.preUploadPhotosList;
export const documentsListSelector = state => state.fileUpload.documentsList;
export const photosListSelector = state => state.fileUpload.photosList;
export const documentsTotalSelector = state => state.fileUpload.documentsTotal;
export const photosTotalSelector = state => state.fileUpload.photosTotal;
export const fileUploadTypeSelector = state => state.fileUpload.fileUploadType;
export const decryptedFlightLogSelector = state =>
	state.fileUpload.documentsList.find(
		item => item.extension === 'csv' && item.name.includes('decrypted_DJIFlightRecord')
	);
